import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { IAccountSearch } from "../../types/webhook";
import { savedSearchWebhooksQueryKeys } from "../key-factory/factory";

export default function useGetAccountSearches(): UseQueryResult<IAccountSearch[]> {
    return useQuery({
        queryKey: savedSearchWebhooksQueryKeys.accountSearches(),
        queryFn({ signal }) {
            return salesApiService.management.getAccountSearches({ cancellation: signal });
        },
    });
}
